import { useEffect } from "react";

interface UseCheckEmailIsEmptyI {
  isMailAvailable: boolean;
  filesCount: number;
  setFullScreenMessage: React.Dispatch<
    React.SetStateAction<Record<string, any>>
  >;
}

export const useCheckEmailIsEmpty = ({
  filesCount,
  isMailAvailable,
  setFullScreenMessage,
}: UseCheckEmailIsEmptyI) => {
  useEffect(() => {
    if (!isMailAvailable) return;
    setFullScreenMessage({
      isShow: !filesCount,
      data: {
        content: "mail-doesnt-contains-files",
        image: { src: "robot", ext: "png", title: "robot", alt: "robot logo" },
        containerCenter: true,
      },
    });
  }, [filesCount, isMailAvailable]);
  return null;
};
